import React from "react";
import Header from "../common/Header";

function PrimaryPageContainer({ classname, background, children }) {
  return (
    <div
      className={`w-full flex flex-col min-h-screen font-poppins items-center relative ${classname} ${
        background || "bg-gray-200"
      }`}
    >
      <Header />
      <div className="w-full max-w-7xl mt-10">{children}</div>
    </div>
  );
}

export default PrimaryPageContainer;
